import { supabase } from './supabaseClient';

// Thin client over the `instagram` Edge Function. Everything sensitive (the
// app secret, the access token) lives server-side — this file only ever sees
// the resulting media, and never talks to Instagram directly.

const FUNCTIONS_BASE = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/instagram`;

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function call(path, options = {}) {
  const res = await fetch(`${FUNCTIONS_BASE}/${path}`, {
    ...options,
    headers: { ...(await authHeaders()), ...(options.headers || {}) },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `Instagram request failed (${res.status})`);
  return body;
}

export async function getInstagramStatus() {
  return call('status');
}

export async function getInstagramMedia() {
  return call('media');
}

export async function disconnectInstagram() {
  return call('disconnect', { method: 'POST' });
}

// A full page navigation, not fetch: the browser has to land on Instagram's
// own consent screen. Deliberately no session token in the URL — query
// strings end up in server logs and browser history, and this route doesn't
// need one: it only bounces to Instagram, where the real gate is having the
// business account's own credentials.
export function startInstagramConnect() {
  window.location.href = `${FUNCTIONS_BASE}/start`;
}
